import { render, staticRenderFns } from "./VideoPlayerController.vue?vue&type=template&id=4087f194&scoped=true&"
import script from "./VideoPlayerController.vue?vue&type=script&lang=js&"
export * from "./VideoPlayerController.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlayerController.vue?vue&type=style&index=0&id=4087f194&prod&scoped=true&lang=css&"
import style1 from "./video_player.css?vue&type=style&index=1&id=4087f194&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4087f194",
  null
  
)

export default component.exports